import {
  EMAIL_CONFIRMATION,
  EMAIL_CONFIRMATION_SUCCESS,
  EMAIL_CONFIRMATION_FAIL
} from "./actionTypes";

export const emailConfirmation = (token) => {
  return {
    type: EMAIL_CONFIRMATION,
    payload: { token },
  }
}

export const emailConfirmationSuccess = success => ({
  type: EMAIL_CONFIRMATION_SUCCESS,
  payload: success,
})

export const emailConfirmationFail = error => ({
  type: EMAIL_CONFIRMATION_FAIL,
  payload: error,
})
